import { useState, useEffect } from 'react';
import api from '@services/api';

function useGuidedOnboarding() {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    api.get('/admin/home/guided_onboarding').then((response) => {
      setCards(response.data.cards);
    });
  }, []);
  return cards;
}

export default useGuidedOnboarding;
